import React from 'react'
import './destiny-free-sample.scss'
import RadioMarkCard from '../../../shared/components/molecules/radio-mark-card/radio-mark-card'
import warning from '../../../assets/images/warning.png'
import { pushGtagEvent } from '../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase';

const DestinyFreeSample = ({
	product,
	recipientS,
	label,
	labelButton,
	handleAction,
	selectDestinySample,
	canAdd,
	talla,
	setcurrentUserTypeId,
	currentUserTypeId,
	animation,
	infoAlert,
}) => {
	const userInfo=dataLayerUserInfo()
	let infoGtag
	if(product){
		infoGtag={
			event:'add_to_cart',
				params:{	
					items: [{ 
					item_id: product.codigoDeProducto||'',
					item_name: product.nombreProducto||'',
					discount: 0,
					affiliation: 'Tena Online',
					item_brand: 'Tena',
					item_category: product.categorias[0].titulo||'',
					item_variant: product.linea[0]? product.linea[0]?.nombreDeEtiqueta : undefined,
					price: 0,
					currency:process.env.LOCALE,
					quantity:1,	
					}],
					option: 'Tena Muestras gratis',
					drip_degree: product.tipoDeIncontinencia? product.tipoDeIncontinencia[0].nombreDeEtiqueta||'' : '',
					flow_type: 'muestra gratis',
					user_data: userInfo.user_data? userInfo.user_data :'',
					log_status: userInfo.log_status|| '',	
				}         
		}
	}else{infoGtag=''}
	return (
		<div className='f-destiny'>
			<div className='f-destiny-content'>
				<div className={`f-destiny-content-info ${animation} `}>
					<h3 className='f-destiny-title'>SOLICITAR MUESTRA GRATIS</h3>
					{talla ? (
						<p className='f-destiny-text'>
							Antes de solicitar tu muestra selecciona la talla que necesitas y
							el perfil con el que te identificas más, después dale clic al
							botón de agregar.
						</p>
					) : (
						<p className='f-destiny-text'>
							Antes de solicitar tu muestra selecciona el perfil con el que te
							identificas más y después dale clic al botón de agregar. Así este
							producto quedará agregado a tu solicitud de muestras y podrás
							seguir con el proceso.
						</p>
					)}
				</div>
				<div className='f-destiny-content-radio'>
					{recipientS.map((value, index) => {
						return (
							<React.Fragment key={index}>
								<RadioMarkCard
									title={value.tipoDeUsuarioUsuarioTitulo}
									description={value.tipoDeUsuarioUsuarioDescripcion}
									image={value.tipoDeUsuarioUsuarioImagen}
									isActive={currentUserTypeId === value.tipoDeUsuarioUsuarioId}
									setActive={() => {
										setcurrentUserTypeId(
											currentUserTypeId === value.tipoDeUsuarioUsuarioId
												? ''
												: value.tipoDeUsuarioUsuarioId
										)
										selectDestinySample(value.tipoDeUsuarioIdMuestras)
									}}
								/>
							</React.Fragment>
						)
					})}
				</div>
			</div>
			<div className='f-destiny-buttons'>
				{(!canAdd || !currentUserTypeId) && (
					<div className='f-destiny-content-alert'>
						{infoAlert.text && (
							<img className='f-destiny-image' src={warning} />
						)}
						<spam className='f-destiny-alert'>{infoAlert.text}</spam>
					</div>
				)}
				<button
					className={`${!canAdd &&
						'f-destiny-button--disabled'} f-destiny-button`}
					onClick={()=>{handleAction(); pushGtagEvent(infoGtag)}} 
				>
					{convertText(labelButton)}
				</button>
			</div>
		</div>
	)
}

export default DestinyFreeSample
